import { calcAverage, calcStdev } from './statistics';

export const normalizerStandard = {
  compute: (values: number[]) => ({
    average: calcAverage(values.filter((value) => !isNaN(value))),
    stdev: calcStdev(values.filter((value) => !isNaN(value))),
  }),
  apply: (computedData: any, value: number) => (value - computedData.average) / computedData.stdev,
};
